import { defineComponent as _defineComponent } from 'vue'
import { ref, onBeforeMount } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { isAuth } from '@/const'


export default /*@__PURE__*/_defineComponent({
  __name: 'AuthWrapper',
  setup(__props, { expose: __expose }) {
  __expose();

const nextParameterValue = new URLSearchParams(window.location.search).get('next')

const isResetForm = ref(false)
const router = useRouter()
const route = useRoute()
const phone = ref('')

const changeForm = (data) => {
  phone.value = data
  isResetForm.value = !isResetForm.value
}

onBeforeMount(() => {
  if(isAuth) window.location.href = nextParameterValue || '/cabinet'
})
// const props = defineProps(['paymentPage', 'mainPage'])

const __returned__ = { nextParameterValue, isResetForm, router, route, phone, changeForm, ref, onBeforeMount, get useRouter() { return useRouter }, get useRoute() { return useRoute }, get isAuth() { return isAuth } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})